import React, { useState, useEffect, useContext, useRef } from 'react';
import { LangContext } from '../../App'
import { ConfirmCodeModal } from './Fields'
import String from '../../Assets/Localization/Local'
import { Link } from 'react-router-dom'
import { useForm } from "react-hook-form";
import { API_ENDPOINT } from '../../AppConfig';
import axios from 'axios'; import './FieldStyle.css';
import './modalStyle.css';
import { Row, Col, Modal, Container } from 'react-bootstrap'
import icon1 from '../../Assets/Images/email.png'
import OkImag from '../../Assets/Images/okkk.png'
import faildImg from '../../Assets/Images/faildImg.png'
// import { reactCodeInput } from 'CodeInputField.scss'
// import ReactCodeInput from 'react-code-input'
// import ReactCodeInput from 'react-verification-code-input';
import PinInput from "react-pin-input";
import Timer from 'react-timer'

function useInterval(callback, delay) {
  const savedCallback = useRef();


  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const ConfirmMailCodeModal = (props) => {


  let confirmModalRef = useRef(null);
  const { lang } = useContext(LangContext)
  const { show, handleModalCancel, HandleConfirmMailDone } = useContext(ConfirmCodeModal)
  const [showConfirmModal, setShow] = useState(false)
  const [showConfirmModalFaild, setShowFaild] = useState(false)
  const [code, setCode] = useState()
  const [error, setError] = useState(false)
  const [count, setCount] = useState(0);
  const [variable, setVariable] = useState("00:00");
  const [reqDone, setReqDone] = useState(false)
  useEffect(() => {
    console.log('confirmModalRef ', confirmModalRef)

  })
  useInterval(() => {
    // Your custom logic here
    if (count != 60) {
      let variable = count + 1 < 10 ? `00:0${count + 1}` : `00:${count + 1}`
      setCount(count + 1)
      setVariable(variable)

    }
  }, 1000);
  const { register, handleSubmit, errors, control, watch, setValue, getValues } = useForm({
    // validationSchema: props.validation
  });

  const inputStyle = {
    textAlign: 'center',
    background: 'rgb(227, 227, 227)',
    borderRadius: '36px',
    fontSize: '22px',
    outline: 'none'
  }
  const handleModalCancelConfirmModal = () => {
    setShow(false)
  }
  const handleShowConfirmModal = () => {
    setShow(true)
  }

  const renderConfirmModall = () => {

    return (
      <Modal style={{ direction: lang === "ar" ? "rtl" : "" }} show={showConfirmModal} onHide={handleModalCancelConfirmModal} animation={false}
        className="AuthModalConfirmCode text-center ConfirmCodeModal">
        <Modal.Header style={{ justifyContent: lang === "en" ? "flex-end" : "" }}>
          {/* <i onClick={handleClose} className="fa fa-close closeBTN"></i> */}
          <i onClick={() => {
            HandleConfirmMailDone(true)
            handleModalCancel()
            handleModalCancelConfirmModal()
          }} className="fa fa-close closeBTN"></i>

          <img src={OkImag} className="confirmImg" />
        </Modal.Header>
        <Modal.Body className="pb-5 text-center">
          <h5 style={{ padding: '0px 51px', marginTop: '22px' }}>{String.mailConfirmed}</h5>
        </Modal.Body>
      </Modal>
    )
  }
  //////////////////////////////////////////

  const renderConfirmModallFaild = () => {

    return (
      <Modal style={{ direction: lang === "ar" ? "rtl" : "" }} show={showConfirmModalFaild} onHide={handleModalCancelConfirmModalFaild} animation={false}
        className="AuthModalConfirmCode text-center ConfirmCodeModal">
        <Modal.Header style={{ justifyContent: lang === "en" ? "flex-end" : "" }}>
          {/* <i onClick={handleClose} className="fa fa-close closeBTN"></i> */}
          <i onClick={() => {
            HandleConfirmMailDone(false)
            handleModalCancel()
            handleModalCancelConfirmModalFaild()
          }} className="fa fa-close closeBTN"></i>

          <img src={faildImg} className="confirmImg" />
        </Modal.Header>
        <Modal.Body className="pb-5 text-center py-5">
          <h5 style={{ padding: '0px 51px', marginTop: '22px' }}>{String.mailConfirmedFaild}</h5>
        </Modal.Body>
      </Modal>
    )
  }
  const handleModalCancelConfirmModalFaild = () => {
    setShowFaild(false)
  }
  const handleShowConfirmModalFaild = () => {
    setShowFaild(true)
  }

  const onSubmit = (data) => {
    console.log('dataa==> ', data, code)

    if (!code) {
      setError(true)
    } else if (code.length !== 5) {
      setError(true)
    }
    else {
      let uri = `${API_ENDPOINT}/confirmEmailCode`
      let submitData = {}
      submitData.email = props.mail
      if (lang === "en") {
        submitData.code = code
      }
      else {
        submitData.code = code
      }
      console.log('submitData---> ', submitData);
      axios.put(uri, submitData, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        console.log('confirm code done=..> ', response.data)
        setReqDone(true);
        handleShowConfirmModal()
      }).catch(error => {
        console.log('confirm code error=..> ', error.response)
        setReqDone(true);
        handleShowConfirmModalFaild()
      })
    }
  }
  const SendMail = () => {
    console.log('hello')

    let uri = `${API_ENDPOINT}/verifyEmail`
    let data = {
      email: props.mail
    }

    console.log('SendMail uri==> ', uri, data)
    axios.post(uri, data, {
      headers: {
        'Content-Type': "application/json"
      }
    }).then(response => {
      console.log('SendMail uri==> ', response)

    }).catch(error => {
      console.log('SendMail uri==>error ', error.response)

    })
  }

  const onChange = value => {
    setCode(value);
    setError(false)
  };
  const resend = () => {
    SendMail()
    setCount(0)
    setVariable("00:00")
  }
  console.log("Code Take Place ===>", code)
  const OPTIONS = { prefix: 'minuits', delay: 1000 }


  return (
    <div >
      <Modal style={{ direction: lang === "ar" ? "" : "", opacity: reqDone === true ? "0" : "1" }} c show={show} onHide={handleModalCancel} animation={false}
        className="AuthModalConfirmCode text-center ConfirmCodeModal" ref={el => (confirmModalRef = el)}>
        <Modal.Header className="justify-content-center pb-0">
          <i style={{ left: lang === "ar" ? "10px" : "", right: lang === "en" ? "20px" : "" }} onClick={handleModalCancel} className="fa fa-close closeBTN"></i>
        </Modal.Header>
        <Modal.Body className="p-0 text-center">
          <div className="imgContainer">
            <img src={icon1} alt="deleteimg" className="forgetimg" style={{ position: 'absolute', left: '0%' }} />
          </div>
          <h5 style={{ padding: '0px 51px', marginTop: '22px' }}>{String.entercode}</h5>
          <div style={{ padding: "10px", height: '20px' }} className="text-center">
            {/* {count !== 60 && <Timer options={OPTIONS} />} */}
            {count !== 60 &&
              <span style={{ color: "orange", fontSize: "20px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
              >
                {variable}
              </span>
            }

            {count === 60 &&
              <span
                style={{ color: "orange", fontSize: "20px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
                onClick={resend}
              >{String.ResendCode}</span>}
          </div>
          <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative', padding: '0px 70px' }}>
            <Row style={{ marginTop: '40px' }}>
              <Col>

              </Col>
              <Col lg='12' style={{ marginBottom: '40px' }}>

                <div className="textWithIcon" style={{ direction: "ltr" }} >
                  <PinInput
                    length={5}
                    focus
                    type="numeric"
                    onChange={onChange}
                  />
                </div>
                <div className="text-center">
                  {error &&
                    <span style={{ color: "red", fontSize: "12px", height: '10px' }}>{String.confirmCodeError}</span>
                  }
                </div>
              </Col>
              {/* <Col className="text-center">
            {error&&
            <span style={{color:"red",fontSize:"12px"}}>{String.confirmCodeError}</span>
            }
              </Col> */}
            </Row>
            <button className="btn nextBTN btn-block mb-4" type="submit"> {String.next} </button>
          </form>


        </Modal.Body>
      </Modal>
      {showConfirmModal === true && renderConfirmModall()}
      {showConfirmModalFaild === true && renderConfirmModallFaild()}
    </div>
  )

}

export default ConfirmMailCodeModal;